// Centralised dashboard IDs file
// Replace placeholder values with your actual Superset dashboard IDs (strings or numbers as required).

// Global dashboards
export const global_executive_overview_dashboard_id = '9f2d7c55-d474-452a-a084-139019885b44';
export const global_executive_metro_performance_dashboard_id = '39980b19-1fe7-443a-bce2-52c7e7b4198d';
export const global_operational_reservoir_supply_dashboard_id = 'a6b2a990-34ef-450c-9578-a9046cf93b80';
export const global_leaks_bursts_nrw_dashboard_id = 'a2283f10-bd44-470b-913a-b50edc51497a';
export const global_infrastructure_risk_maintenance_dashboard_id = '617a0ec6-dc63-498c-aaa2-13b5ef49d051';
export const global_demand_management_behaviour_dashboard_id = '43215f44-6eda-449b-bfd1-9a0699b7eb1c';
export const global_water_quality_public_health_dashboard_id = '0830bbce-c989-46f8-b202-0d1b43220c12';
export const global_impact_exchange_rate_engine_dashboard_id = '155dee9b-29e1-4e51-b26c-763cc4a57310';
export const global_fund_performance_capital_recycling_dashboard_id = '40f6bff9-5cd6-44d3-b87e-f44c334aea99';
export const global_real_time_operations_asset_control_dashboard_id = 'e93eb977-5d9a-499b-8d2f-1d7dc39dd4ae';

// Role-based global dashboard mappings (per sidebar nav key)
export const role_dashboards = {
  fund_manager: {
    default: global_executive_overview_dashboard_id,
    'executive-overview': global_executive_overview_dashboard_id,
    'executive-metro-performance': global_executive_metro_performance_dashboard_id,
    'operational-reservoir-supply': global_operational_reservoir_supply_dashboard_id,
    'leaks-bursts-nrw': global_leaks_bursts_nrw_dashboard_id,
    'infrastructure-risk-maintenance': global_infrastructure_risk_maintenance_dashboard_id,
    'demand-management-behaviour': global_demand_management_behaviour_dashboard_id,
    'water-quality-public-health': global_water_quality_public_health_dashboard_id,
    'impact-exchange-rate-engine': global_impact_exchange_rate_engine_dashboard_id,
    'fund-performance-capital-recycling': global_fund_performance_capital_recycling_dashboard_id,
    'real-time-operations-asset-control': global_real_time_operations_asset_control_dashboard_id,
    'public-trust-citizen-view': '3350ddfc-5ac5-42ac-bcf0-5db78d898a43'
  },
  donor: {
    default: '6f526287-7ed6-4c6f-aca3-1f46d20611e4',
    'impact-dashboard': '6f526287-7ed6-4c6f-aca3-1f46d20611e4',
    'ssin-portfolio': '4a7aab0b-2c75-4b5e-92f9-d87090053c04',
    'adopted-assets': '7c0cba7b-ba74-411f-bbbb-994b147f89b0',
    'impact-reports': '4a4867ad-7184-4026-865f-c50644d143f4',
    'financials-tax': '939b23f5-4e7b-4451-9121-57158a5848ed',
    'documents': 'REPLACE_DONOR_DOCUMENTS_DASHBOARD_ID'
  },
  governance: {
    default: 'REPLACE_GOVERNANCE_OVERVIEW_DASHBOARD_ID',
    'governance-overview': 'REPLACE_GOVERNANCE_OVERVIEW_DASHBOARD_ID',
    'risk-management': 'REPLACE_GOVERNANCE_RISK_DASHBOARD_ID',
    'audit-findings': 'REPLACE_GOVERNANCE_AUDIT_DASHBOARD_ID',
    'compliance': 'REPLACE_GOVERNANCE_COMPLIANCE_DASHBOARD_ID',
    'controls': 'REPLACE_GOVERNANCE_CONTROLS_DASHBOARD_ID',
    'board-management': 'REPLACE_GOVERNANCE_BOARD_DASHBOARD_ID'
  },
  entrepreneur: {
    default: 'REPLACE_ENTREPRENEUR_MY_BUSINESS_DASHBOARD_ID',
    'my-business': 'REPLACE_ENTREPRENEUR_MY_BUSINESS_DASHBOARD_ID',
    'earnings-payouts': 'REPLACE_ENTREPRENEUR_EARNINGS_PAYOUTS_DASHBOARD_ID',
    'training-certs': 'REPLACE_ENTREPRENEUR_TRAINING_CERTS_DASHBOARD_ID',
    'maintenance': 'REPLACE_ENTREPRENEUR_MAINTENANCE_DASHBOARD_ID',
    'support': 'REPLACE_ENTREPRENEUR_SUPPORT_DASHBOARD_ID'
  }
};
